export const Badge = (props: any) => {
    return (
        <span className={`badgebadge-pill hr-badge-${props.status.toLowerCase()}`} >{props.text}</span>
    );
};